export enum ObjetivosEstrategicos {
  OBJ_1_1 = 'Consolidar o equilíbrio fiscal',
  OBJ_1_2 = 'Aumentar a capacidade e a efetividade de investimentos',
  OBJ_1_3 = 'Intensificar as parcerias com o setor privado e o Terceiro Setor, qualificando e incrementando a infraestrutura e a prestação de serviços',
  OBJ_2_1 = 'Assegurar o alinhamento estratégico e a atuação transversal em todos os níveis do governo',
  OBJ_2_2 = 'Consolidar os mecanismos de transparência e de governança',
  OBJ_2_3 = 'Promover o engajamento, a participação social e a articulação regional',
  OBJ_2_4 = 'Valorizar e desenvolver os servidores',
  OBJ_2_5 = 'Modernizar e agilizar os processos',
  OBJ_2_6 = 'Promover a moderna e eficiente governança de dados',
  OBJ_3_1 = 'Proporcionar educação de qualidade, inclusiva e equitativa, em um ambiente acolhedor e inspirador',
  OBJ_3_2 = 'Promover a saúde e o bem-estar com assistência adequada, ágil e de qualidade',
  OBJ_3_3 = 'Combater a pobreza e garantir a segurança alimentar das famílias em situação de vulnerabilidade',
  OBJ_3_4 = 'Promover políticas de equidade, inclusão social produtiva e habitação',
  OBJ_3_5 = 'Disseminar a cultura de paz e fortalecer a segurança e o combate ao crime',
  OBJ_3_6 = 'Promover ações integradas de cuidados e proteção para a Primeira Infância',
  OBJ_4_1 = 'Aprimorar a infraestrutura e diversificar os modais de transporte, reduzindo custos logísticos',
  OBJ_4_2 = 'Fomentar ecossistemas de inovação e incentivar o aumento da produtividade da economia',
  OBJ_4_3 = 'Promover a sustentabilidade ambiental, fomentando a transição energética e a adaptação às mudanças climáticas',
  OBJ_4_4 = 'Fortalecer a articulação com os municípios e o desenvolvimento regional',
  OBJ_4_5 = 'Promover justiça tributária, aperfeiçoando e simplificando o modelo de tributação',
  OBJ_4_6 = 'Aprimorar as soluções ao cidadão por meio do governo digital',
  OBJ_4_7 = 'Fomentar uma agenda de desenvolvimento e um ambiente de negócios mais ágil, articulado e inovador',
}
